module.exports = __webpack_public_path__ + "assets/menu.ae9f2885.svg";